export default function (dom) {
  dom = dom || document.getElementById('base-popup');
  return {
    mounted() {
      dom.appendChild(this.$el);
    },
    destroyed() {
      if(this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },
  }
}
